import { apiClient } from './api'

export interface ClientRegistryEnvironment {
  project_id?: string
  base_url?: string
  secret_name?: string
}

export interface ClientRegistryRow {
  tenant_id: string
  client_name: string
  client_id: string
  status: string
  country: string | null
  primary_country: string | null
  applicable_countries: string[]
  tier: string | null
  auth0_org_id: string | null
  rules_gcs_path: string | null
  contact_name: string | null
  contact_email: string | null
  customers: string[]
  environments: Record<string, ClientRegistryEnvironment> | null
  notes: string | null
  onboarded_at: string | null
  updated_at?: string | null
}

export interface ClientOnboardingIntake {
  tenant_id?: string
  client_name: string
  country: string
  applicable_countries?: string[]
  tier?: string
  contact: {
    name: string
    email: string
  }
  customers?: string[]
  target_environments?: string[]
  notes?: string
  auth0_org_id?: string
  rules_gcs_path?: string
}

export interface ProvisionApiKeyResponse {
  tenant_id: string
  secret_name: string
  api_key: string
  base_url: string
  environment: string
  client: ClientRegistryRow
}

export interface SyncClientsJsonResponse {
  bucket: string
  object: string
  tenant_id: string
  updated: boolean
}

export const getClientRegistry = async () => {
  return apiClient.get<ClientRegistryRow[]>('/client-registry')
}

export const createClientFromIntake = async (intake: ClientOnboardingIntake) => {
  return apiClient.post<ClientRegistryRow>('/client-registry/intake', intake)
}

export const provisionClientApiKey = async (tenantId: string) => {
  return apiClient.post<ProvisionApiKeyResponse>(
    `/client-registry/${encodeURIComponent(tenantId)}/provision-api-key`,
  )
}

export const syncClientToGcsRegistry = async (tenantId: string) => {
  return apiClient.post<SyncClientsJsonResponse>(
    `/client-registry/${encodeURIComponent(tenantId)}/sync-clients-json`,
  )
}
